import { Component, Inject, ChangeDetectionStrategy, TemplateRef } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

import { TextConstants } from "@shared/constants";

@Component({
  standalone: false,
  selector: "app-fullscreen-dialog",
  templateUrl: "./fullscreen-dialog.component.html",
  styleUrls: ["./fullscreen-dialog.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FullScreenDialogComponent {
  public readonly translations: any = {
    closeTp: TextConstants.CLOSE,
  };

  constructor(
    private dialogRef: MatDialogRef<FullScreenDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { template: TemplateRef<unknown> },
  ) {}

  public onClose(): void {
    this.dialogRef.close();
  }
}
